var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8997 5.98333H5.49967C4.52778 5.98333 3.73301 6.7781 3.73301 7.75V16.0833C3.73301 17.0552 4.52778 17.85 5.49967 17.85H15.4997C16.4716 17.85 17.2663 17.0552 17.2663 16.0833V7.75C17.2663 6.7781 16.4716 5.98333 15.4997 5.98333H14.7663V4.41667C14.7663 2.06144 12.8549 0.15 10.4997 0.15C8.14445 0.15 6.23301 2.06144 6.23301 4.41667V4.51667H6.33301H7.99967H8.09967V4.41667C8.09967 3.08856 9.17157 2.01667 10.4997 2.01667C11.8278 2.01667 12.8997 3.08856 12.8997 4.41667V5.98333ZM5.59967 15.9833V7.85H15.3997V15.9833H5.59967ZM10.4997 13.6833C11.4716 13.6833 12.2663 12.8886 12.2663 11.9167C12.2663 10.9448 11.4716 10.15 10.4997 10.15C9.52778 10.15 8.73301 10.9448 8.73301 11.9167C8.73301 12.8886 9.52778 13.6833 10.4997 13.6833Z",
    fill: "url(#paint0_linear_4007_6432)",
    stroke: "url(#paint1_linear_4007_6432)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4007_6432",
    x1: 5.06108,
    y1: 1.40132,
    x2: 19.3358,
    y2: 13.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A416F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4007_6432",
    x1: 5.06108,
    y1: 1.40132,
    x2: 19.3358,
    y2: 13.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A416F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.118e6373b3cc100f9d11c53741380e88.svg";
export { ForwardRef as ReactComponent };